// extracted by mini-css-extract-plugin
export default {"addPro":"AssignedProList_addPro__Skmot"};